import {
  Box,
  Button,
  Chip,
  Divider,
  IconButton,
  Input,
  List,
  ListItem,
  ListItemText,
  Modal,
  Typography,
  CircularProgress,
} from "@mui/material";
import Cancel from "@mui/icons-material/Cancel";
import axios from "axios";
import { GoogleApiWrapper, Map, Marker, Polyline } from "google-maps-react";
import moment from "moment";
import React, { useEffect, useMemo, useRef, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import SendIcon from "@mui/icons-material/Send";
import { baseUrl } from "../utils/constants";
import localizationStrings from "../utils/localizations";
import "./Chat.css";
import { FullScreen, useFullScreenHandle } from "react-full-screen";

export default function Chat(props) {
  const [chat, setChat] = useState([]);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [chatLoading, setChatLoading] = useState(false);

  const getChat = async (silent = true) => {
    try {
      if (!silent) setChatLoading(true);
      const data = await axios.get(baseUrl + "chat/" + props.guidanceId);
      if (data.data.status) {
        setChat(data.data.result.reverse());
      } else {
        alert(data.data.message || "An Error occured");
      }
      if (!silent) setChatLoading(false);
    } catch (e) {
      if (!silent) setChatLoading(false);
      // alert(e.message);
      console.warn(e);
    }
  };

  const sendChat = async (silent = false) => {
    try {
      if (!silent) setLoading(true);
      const data = await axios.post(baseUrl + "chat/" + props.guidanceId, { message: message });
      if (data.data.status) {
        setMessage("");
        await getChat();
      } else {
        alert(data.data.message || "An Error occured");
      }
      if (!silent) setLoading(false);
    } catch (e) {
      if (!silent) setLoading(false);
      // alert(e.message);
      console.warn(e);
    }
  };

  useEffect(() => {
    setChat([]);
    setMessage("");
    setLoading(false);
    if (props.guidanceId == null) {
      if (props.visible) {
        props.handleClose();
      }
      return;
    }

    getChat(false);

    const interval = setInterval(() => {
      getChat(true);
    }, 5000);

    return () => {
      clearInterval(interval);
    };
  }, [props.guidanceId]);

  if (!props.visible) {
    return null;
  }
  return (
    <div className="modal-container">
      <div aria-hidden="true" className="modal-back" onClick={props.handleClose}></div>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "90%", sm: "70%", md: "60%", lg: "40%", xl: "30%" },
          bgcolor: "background.paper",
          borderRadius: 1,
          boxShadow: 24,
          p: 4,
        }}
      >
        <Box
          sx={{ position: "absolute", top: 20, [localizationStrings.getLanguage() === "ar" ? "left" : "right"]: 20 }}
        >
          <IconButton onClick={props.handleClose}>
            <CloseIcon />
          </IconButton>
        </Box>

        {/* <Typography id='modal-modal-description' sx={{ mt: 5, textAlign: 'center', fontWeight: '700', fontSize: 18 }}>
          {'currentSelected.Full_Name'}
        </Typography> */}
        <div style={{ height: 50 }}>
          <Typography id="modal-modal-description" sx={{ mt: 5, textAlign: "center", fontWeight: "700", fontSize: 18 }}>
            {props.title}
          </Typography>
        </div>

        {chatLoading ? (
          <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <CircularProgress />
          </Box>
        ) : chat.length <= 0 ? (
          <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <Typography>No chat messages present</Typography>
          </Box>
        ) : (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column-reverse",
              alignItems: "center",
              maxHeight: "60vh",
              overflowY: "scroll",
            }}
          >
            {chat.map((item, index) => (
              <div key={index} className={item.from_admin ? "message-right" : "message-left"}>
                {/* <Chip label={item.from_admin ? 'Admin' : 'User'} color={item.from_admin ? 'primary' : 'secondary'} variant='outlined' sx={{ mr: 1 }} /> */}
                <Typography>{item.message}</Typography>
              </div>
            ))}
          </Box>
        )}

        <div style={{ height: 20 }} />

        <Input
          style={{ backgroundColor: "#fff", width: "100%" }}
          placeholder={localizationStrings.EnterYourMessage}
          color="primary"
          value={message}
          onChange={(e) => {
            setMessage(e.nativeEvent.target.value);
          }}
          onSubmit={(e) => {
            e.preventDefault();
            sendChat();
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              sendChat();
            }
          }}
          endAdornment={
            <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
              {loading ? (
                <CircularProgress />
              ) : (
                <IconButton type="submit" onClick={() => sendChat()}>
                  <SendIcon />
                </IconButton>
              )}
            </Box>
          }
        />
      </Box>
    </div>
  );
}
